import React from "react";
import Pagination from "@mui/material/Pagination";
import { Box } from "@mui/system";

export default function PaginationRounded({qtdPaginas, clickPaginacao}) {

  return (
    <Box sx={{ "& > *": { marginTop: 2 } }}>
      <Pagination
        count={qtdPaginas}
        variant="outlined"
        shape="rounded"
        onChange={clickPaginacao}
        sx={{
          "& .MuiPaginationItem-root": {
            color: "var(--cor-roxoEscuro)",
            borderColor: "var(--cor-cinzaMargin)",
            width: "35px",
            height: "35px",
            borderRadius: "30%",
            fontSize: "18px",
            alignItems: "center",
            justifyContent: "center",
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            backgroundColor: "var(--cor-roxoEscuro)",
            color: "var(--cor-branco)",
          },
        }}
      />
    </Box>
  );
}
